import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DataCacheService } from 'src/app/features/working-area/components/working-area2/services/data/data-cache.service';
import { RootTest } from '../interfaces/test-response';
import { LogoutService } from './logout.service';
import { NotificationService } from './notification.service';
import { StorageBrowser } from './storage.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  public eventEmitter = new EventEmitter();
  public currTest = new BehaviorSubject<RootTest | null>(null);
  public packetLockEvent = new BehaviorSubject<boolean | null>(null);
  public checkUser: any = false;

  constructor(
    public notificationService: NotificationService,
    public dataCacheService: DataCacheService,
    public storageBrowser: StorageBrowser,
    private userService: UserService,
    private logoutService: LogoutService
  ) {}

  public logout(message?: string) {
    this.logoutService.logout(message);
  }

  public async clearAllIndexedDB() {
    try {
      await this.dataCacheService.clear();
      console.log('local db is cleared');
    } catch (error) {
      console.log('there is error in clearing local db');
      console.error({ error });
    }
  }
}
